// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { EStatus } from '../../node/repositories/newbuilding-card/entities/reviews/Like';
import { getNewReactionCount } from '../mappers/getNewReactionCount';
import { IReviews } from '../types/newbuilding/reviews';

export type TChangeReviewReactionType = {
  reviews?: IReviews | null;
  payload: {
    reviewId: string;
    type: EStatus;
  };
};

export const changeReviewReactionType = ({ reviews, payload }: TChangeReviewReactionType) => {
  if (!reviews) {
    return null;
  }

  return {
    ...reviews,
    reviews: reviews.reviews.map(review => {
      if (review.id === payload.reviewId) {
        return {
          ...review,
          like: {
            ...getNewReactionCount(review.like.status)[payload.type](review.like),
            status: payload.type,
          },
        };
      }

      return review;
    }),
  };
};
